/* eslint-disable indent */
import './styles.scss';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { getGeneralInfoProjectForCouncil } from 'apis/projects.api';
import { PROJECT_ROLES } from 'constant';
import { formatDate, getAcadamicLevelShortHand, formatCurrency } from 'utils/func';
import ResearchFields from './ResearchFields';

export default function GeneralInfo() {
  const { t } = useTranslation();
  const { projectId } = useParams();

  // #region get general info
  const { data: generalInfoData } = useQuery(['generalInfo', projectId], () =>
    getGeneralInfoProjectForCouncil(projectId)
  );
  const generalInfo = useMemo(() => generalInfoData?.data, [generalInfoData]);
  const projectProposalInfo = useMemo(() => generalInfo?.projectProposal, [generalInfo]);
  // const projectExpenditurePeriods = useMemo(() => generalInfo?.projectExpenditurePeriods, [generalInfo]);
  const owner = useMemo(() =>
    projectProposalInfo?.projectProposalContacts.find(
      (contact) => contact?.projectRole?.code === PROJECT_ROLES.OWNER
    )
  );

  return (
    <div className="general-infor-r05">
      {/* A */}
      <h4 className="font-bold">{t('r05.a.title')}</h4>
      {/* A1 */}
      <section>
        <h5 className="my-2 ">{t('r05.a.a1.title')}</h5>
        <p className="my-2 pl-4">
          - <span className="font-semibold">{t('r05.a.a1.vietnameseName')}: </span>
          {projectProposalInfo?.vietnameseName}
        </p>
        <p className="my-2 pl-4">
          - <span className="font-semibold ">{t('r05.a.a1.englishName')}: </span>
          {projectProposalInfo?.englishName}
        </p>
      </section>
      {/* A2 */}
      <section>
        <h5>{t('r05.a.a2.title')}</h5>
        <ResearchFields researchFields={projectProposalInfo?.projectProposalResearchFields} />
      </section>
      {/* A3  */}
      <section>
        <h5>{t('r05.a.a3.title')}</h5>
        <p className="flex-1 ml-5">
          <span className="font-semibold">
            {t('projectProposal.general.researchType.researchType')}:{' '}
          </span>
          {projectProposalInfo?.researchType?.code
            ? t(`researchTypes.${projectProposalInfo?.researchType?.code}`)
            : projectProposalInfo?.researchType?.name}
        </p>
      </section>
      {/* A4  */}
      <section>
        <h4>{t('r05.a.a4.title')}</h4>
        <p className="my-2">
          &emsp;- &ensp;{t('r05.a.a4.timeFrom')} {new Date(generalInfo?.startDate).getMonth() + 1}/
          {new Date(generalInfo?.startDate).getFullYear()} {t('r05.a.a4.timeTo')}{' '}
          {new Date(generalInfo?.endDate).getMonth() + 1}/
          {new Date(generalInfo?.endDate).getFullYear()}
        </p>
        <p className="my-2">
          &emsp;- &ensp;{t('r05.a.a4.renewFrom')} ............ {t('r05.a.a4.renewTo')} ...........
        </p>
      </section>
      {/* A5  */}
      <section>
        <h4>{t('r05.a.a5.title')}</h4>
        <p className="my-2">
          &emsp;- &ensp;{t('r05.a.a5.totalExpenditure')}{' '}
          <span className="font-italic">
            {formatCurrency(generalInfo?.totalExpenditure)} {t('r05.a.a5.milionDong')}{' '}
          </span>
          {t('r05.a.a5.include')}
        </p>
        <p className="my-2">
          &emsp;&emsp;- &ensp;{t('r05.a.a5.expenditureFromVNU')}{' '}
          <span className="font-italic">
            {formatCurrency(generalInfo?.totalExpenditure)} {t('r05.a.a5.milionDong')}
          </span>
        </p>
        <p className="my-2">
          &emsp;&emsp;&emsp; + {t('r05.a.a5.expenditure1st')} ......... {t('r05.a.a5.followUp')}{' '}
          .....
          {t('r05.a.a5.day')}
        </p>
        <p className="my-2">
          &emsp;&emsp;&emsp; + {t('r05.a.a5.expenditure2nd')} ......... {t('r05.a.a5.followUp')}{' '}
          .....
          {t('r05.a.a5.day')}
        </p>
        <p className="my-2">
          &emsp;&emsp;- &ensp;{t('r05.a.a5.expenditureFromFunding')}{' '}
          <span className="font-italic">
            {formatCurrency(generalInfo?.expenditureFromFunding)} {t('r05.a.a5.milionDong')}
          </span>
        </p>
      </section>
      {/* A6  */}
      <section>
        <h5 className="">{t('r05.a.a6.title')}</h5>
        <p className="my-2">
          <span className="font-semibold ml-3">{t('r05.a.a6.name')}</span>
          {`${getAcadamicLevelShortHand(owner?.academicRank, owner?.academicDegree, t, true)} ${
            owner?.fullname
          } ` ?? '................'}
        </p>
        <p className="my-2">
          <span className="font-semibold ml-3">{t('r05.a.a6.birthDate')}</span>
          {formatDate(owner?.dob) ?? '................'}
          <span className="font-semibold ml-6">{t('r05.a.a6.sex')}</span>
          {owner?.gender ?? '................'}
        </p>
        <p className="my-2">
          <span className="font-semibold ml-3">{t('r05.a.a6.company')}</span>
          {owner?.organization?.name ?? '................'}
        </p>
        <p className="my-2">
          <span className="font-semibold ml-3">{t('r05.a.a6.phone')}</span>
          {owner?.mobile ?? '................'}
          <span className="font-semibold ml-6">{t('r05.a.a6.email')}</span>
          {owner?.email ?? '..........'}
        </p>
      </section>
      {/* A7  */}
      <section>
        <h5 className="">{t('r05.a.a7.title')}</h5>
        {projectProposalInfo?.projectProposalOrganizations
          ?.filter((org) => org.type === 'LEAD')
          ?.map((org) => (
            <div>
              <p className="my-2">
                <span className="font-semibold ml-3">{t('r05.a.a7.companyName')}</span>
                {/* eslint-disable-next-line no-nested-ternary */}
                {org?.englishName === 'Other'
                  ? org?.name
                  : t('lang') === 'vi'
                  ? org?.name
                  : org?.englishName}
              </p>
              <p className="my-2">
                <span className="font-semibold ml-3">{t('r05.a.a7.leaderName')}</span>
                {org?.chief ?? '........'}
              </p>
              <div className="flex align-items-center my-2">
                <p className=" mb-0">
                  <span className="font-semibold ml-3">{t('r05.a.a7.phone')}</span>
                  {org?.phone ?? '........'}
                </p>
                <p className="mb-0">
                  <span className="font-semibold ml-6">{t('r05.a.a7.fax')}</span>
                  {org?.fax ?? '.......'}
                </p>
                <p />
              </div>
              <p className="my-2">
                <span className="font-semibold ml-3">{t('r05.a.a7.email')}</span>
                {org?.email ?? '........'}
              </p>
            </div>
          ))}
      </section>
    </div>
  );
}
